if (!customElements.get('phc-review-highlight')) customElements.define('phc-review-highlight', class extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.addEventListener('click', event => {
      const button = event.target.closest('[data-review-index]');
      if (!button) return;
      const index = Number(button.dataset.reviewIndex);
      this.querySelectorAll('[data-review-slide]').forEach((slide, i) => { slide.hidden = i !== index; });
      this.querySelectorAll('[data-review-index]').forEach(control => control.setAttribute('aria-pressed', String(control === button)));
    });
  }
});
if (!customElements.get('phc-try-on')) customElements.define('phc-try-on', class extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    const video = this.querySelector('video');
    const button = this.querySelector('[data-try-on-play]');
    const loadPoster = () => {
      if (!video.poster) video.poster = video.dataset.poster;
      this.observer?.disconnect();
    };
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) loadPoster();
      }, {rootMargin: '300px'});
      this.observer.observe(this);
    } else loadPoster();
    button.addEventListener('click', async () => {
      loadPoster();
      if (!video.getAttribute('src')) video.src = video.dataset.videoSrc;
      try { await video.play(); button.hidden = true; } catch { button.hidden = false; }
    });
  }
  disconnectedCallback() { this.observer?.disconnect(); }
});
